// extracted by mini-css-extract-plugin
export var deleteModal = "_qo-0";